import classNames from "classnames"
import { FC, ReactNode } from "react"
import { FormikProps } from 'formik';
import { get } from 'lodash';

interface Props {
  label?: string
  value?: string
  placeholder?: string
  object?: ReactNode
  required?: boolean
  disabled?: boolean
  formik?: FormikProps<any>
  fieldName?: string
  enableInputLength?: boolean
  inputLength?: number
}

const CustomInputRenderer: FC<Props> = ({
  label,
  value,
  placeholder,
  object,
  required,
  disabled,
  formik,
  fieldName,
  enableInputLength = false,
  inputLength = 255
}: Props) => {
  return (
    <>
      {formik ? (
        <div className='row'>
          <label className='d-flex flex-column-auto flex-start align-items-start col-xxl-3 fs-6 col-form-label col-form-label-sm'>
            <span className={classNames('text-gray-700', {required: required})}>{label}</span>
          </label>

          <div className='col-xxl-9'>
            {object ? (
              <>
                {object}
                <div className='d-flex flex-row p-1'>
                  <div className='d-flex flex-column flex-row-fluid'>
                    <div className='d-flex flex-row flex-column-fluid'>
                      <div className='d-flex flex-row-fluid flex-start'>
                        {get(formik.touched, `${fieldName}`) &&
                          get(formik.errors, `${fieldName}`) && (
                            <span className='fs-8 text-danger'>
                              {get(formik.errors, `${fieldName}`)?.toUpperCase() ?? ''}
                            </span>
                          )}
                      </div>
                      {formik &&
                        enableInputLength &&
                        get(formik.values, `${fieldName}`)?.length > 0 && (
                          <div className='d-flex flex-row-auto flex-end align-items-start'>
                            <span className='fs-8 text-muted'>{`${
                              get(formik.values, `${fieldName}`)?.length || 0
                            }/${inputLength}`}</span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <input
                  type='text'
                  className='form-control form-control-sm form-control-solid px-5 py-0 fs-6 text-dark'
                  placeholder={placeholder ? `${placeholder}` : ''}
                  {...formik.getFieldProps(`${fieldName}`)}
                  onChange={formik.handleChange}
                  disabled={disabled}
                />

                <div className='d-flex flex-row p-1'>
                  <div className='d-flex flex-column flex-row-fluid'>
                    <div className='d-flex flex-row flex-column-fluid'>
                      <div className='d-flex flex-row-fluid flex-start'>
                        {get(formik.touched, `${fieldName}`) &&
                          get(formik.errors, `${fieldName}`) && (
                            <span className='fs-8 text-danger'>
                              {get(formik.errors, `${fieldName}`)?.toUpperCase() ?? ''}
                            </span>
                          )}
                      </div>

                      {formik &&
                        enableInputLength &&
                        get(formik.values, `${fieldName}`)?.length > 0 && (
                          <div className='d-flex flex-row-auto flex-end align-items-start'>
                            <span className='fs-8 text-muted'>{`${
                              get(formik.values, `${fieldName}`)?.length || 0
                            }/${inputLength}`}</span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className='row mb-5'>
          <label className='col-xxl-3 text-gray-700 fs-6'>{label ?? ''}</label>
          <div className='col-xxl-9'>
            {object ? object : <span className='fs-6 ms-3 text-dark'>{value ?? ''}</span>}
          </div>
        </div>
      )}
    </>
  )
}

export {CustomInputRenderer}
